/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';

import type { DetailsGrid } from '@swf/cms';
import { CMSCTA, CMSPageSection } from '@swf/cms';

import styles from './CMSDetailsGrid.scss';
import CMSDetailsGridItem from './CMSDetailsGridItem';

const CMSDetailsGrid: React.FC<DetailsGrid> = ({
  heading,
  intro,
  item_alignment,
  items,
  cta,
  number_of_columns = 2,
  type = ''
}) =>
  heading.title || intro.content || items.length ? (
    <>
      <CMSPageSection
        heading={heading}
        intro={intro}
        grid
        columns={number_of_columns}
        gridClassName={styles[type as string]}
      >
        {items.length &&
          items.map((item, index) => (
            <CMSDetailsGridItem {...item} alignment={item_alignment} key={index} />
          ))}
      </CMSPageSection>
      <CMSCTA {...cta} />
    </>
  ) : null;

export default CMSDetailsGrid;
